import script from "./Consents.vue?vue&type=script&setup=true&lang=js"
export * from "./Consents.vue?vue&type=script&setup=true&lang=js"

import "./Consents.vue?vue&type=style&index=0&id=48184596&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48184596"]])

export default __exports__